/* eslint-disable */
import dynamic from 'next/dynamic';


import GoogleTagManagerNoscript from '@magalu/mixer-modules/build/esm/novisual/GoogleTagManagerNoscript';
import AdsBanner from '@magalu/mixer-modules/build/esm/components/ecommerce/AdsBanner';
import ExternalContent from '@magalu/mixer-modules/build/esm/components/ecommerce/ExternalContent';
import HeaderDesktop from '@magalu/mixer-modules/build/esm/components/ecommerce/HeaderDesktop';
import Heading from '@magalu/mixer-modules/build/esm/components/ecommerce/Heading';
import Link from '@magalu/mixer-modules/build/esm/components/ecommerce/Link';
import CustomPagination from '@magalu/mixer-modules/build/esm/components/ecommerce/CustomPagination';
import BrandList from '@magalu/mixer-modules/build/esm/components/ecommerce/BrandList';
import FooterDesktop from '@magalu/mixer-modules/build/esm/components/ecommerce/FooterDesktop';
import Ebit from '@magalu/mixer-modules/build/esm/novisual/Ebit';
import ReclameAqui from '@magalu/mixer-modules/build/esm/novisual/ReclameAqui';
import Favicon from '@magalu/mixer-modules/build/esm/novisual/Favicon';
import Preconnect from '@magalu/mixer-modules/build/esm/novisual/Preconnect';
import Datadog from '@magalu/mixer-modules/build/esm/novisual/Datadog';
import GoogleTagManagerHead from '@magalu/mixer-modules/build/esm/novisual/GoogleTagManagerHead';
import Stewie from '@magalu/mixer-modules/build/esm/novisual/Stewie';
import AllIn from '@magalu/mixer-modules/build/esm/novisual/AllIn';
import Criteo from '@magalu/mixer-modules/build/esm/novisual/Criteo';
import TikTok from '@magalu/mixer-modules/build/esm/novisual/TikTok';
import SpotifyAdAnalytics from '@magalu/mixer-modules/build/esm/novisual/SpotifyAdAnalytics';
import RTBHouse from '@magalu/mixer-modules/build/esm/novisual/RTBHouse';
import Vwo from '@magalu/mixer-modules/build/esm/novisual/Vwo';
import Azion from '@magalu/mixer-modules/build/esm/novisual/Azion';
import Bing from '@magalu/mixer-modules/build/esm/novisual/Bing';

const pageModules = {
  GoogleTagManagerNoscript,
  AdsBanner,
  ExternalContent,
  HeaderDesktop,
  Heading,
  Link,
  CustomPagination,
  BrandList,
  FooterDesktop,
  Ebit,
  ReclameAqui,
  Favicon,
  Preconnect,
  Datadog,
  GoogleTagManagerHead,
  Stewie,
  AllIn,
  Criteo,
  TikTok,
  SpotifyAdAnalytics,
  RTBHouse,
  Vwo,
  Azion,
  Bing,
  ZipCodeInput: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/ZipCodeInput'),
    { ssr: false }
  ),
  Loader: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/Loader'),
    { ssr: false }
  ),
};

export default pageModules;
